import { render } from "./RemoveModal.vue?vue&type=template&id=5b7d9720&ts=true"
import script from "./RemoveModal.vue?vue&type=script&lang=ts"
export * from "./RemoveModal.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__